import { type FC } from 'react';

import { LeadCardProvider } from '@app/components/LeadCard/context';
import type { LeadCardProps } from '@app/components/LeadCard/LeadCard.types';
import { Layout } from '@app/components/LeadCard/ui/Layout';

export const LeadCard: FC<LeadCardProps> = ({
  leadId,
  className,
  showLeadList,
  showGoToLeadAction,
  knownClientId,
  leads,
  hasNextLeadsPage,
  onBackToLeads,
  onLoadNextLeads,
  onLeadClick,
  onLeadUpdated,
  isLeadsLoading,
  isNextLeadsPageLoading,
  isBranchesLoading,
  isMessagesLoading,
  isFooterLoading,
  isUserDetailsLoading,
  viewConfig,
}) => (
  <LeadCardProvider
    leadId={leadId}
    className={className}
    showLeadList={showLeadList}
    showGoToLeadAction={showGoToLeadAction}
    knownClientId={knownClientId}
    leads={leads}
    hasNextLeadsPage={hasNextLeadsPage}
    onBackToLeads={onBackToLeads}
    onLoadNextLeads={onLoadNextLeads}
    onLeadClick={onLeadClick}
    onLeadUpdated={onLeadUpdated}
    isLeadsLoading={isLeadsLoading}
    isNextLeadsPageLoading={isNextLeadsPageLoading}
    isBranchesLoading={isBranchesLoading}
    isMessagesLoading={isMessagesLoading}
    isFooterLoading={isFooterLoading}
    isUserDetailsLoading={isUserDetailsLoading}
    viewConfig={viewConfig}
  >
    <Layout />
  </LeadCardProvider>
);
